function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  d: "m55.84 347.017c0 96.914 92.732 159.849 96.68 162.481 11.574 7.715 26.571-3.204 22.743-16.602-23.519-82.315-20.855-167.831 42.611-225.83-7.736 28.508-5.681 51.722 6.139 69.082 22.761 33.43 73.333 32.617 113.188 26.632 30.847 27.212 8.84 90.296-9.776 127.528-6.867 13.735 9.056 27.642 21.737 19.189 67.218-44.812 103.146-101.065 106.788-167.197 6.657-120.96-104.308-262.304-195.47-338.775-9.735-8.167-24.641-1.235-24.641 11.492 0 84.27-43.886 125.436-90.348 169.02-44.075 41.345-89.651 84.097-89.651 162.98zm207.943-299.943c76.017 72.537 167.998 189.022 162.207 293.627-2.229 40.28-19.037 76.565-50.096 108.354 24.33-87.765-25.813-114.188-28.347-115.455-2.836-1.418-6.049-1.9-9.174-1.379-47.415 7.902-78.379 3.431-89.546-12.931-15.495-22.701 6.082-69.818 14.875-84.556 7.375-12.29-5.133-26.961-18.433-21.645-45.746 18.301-134.068 91.939-109.142 242.719-23.267-24.257-50.287-62.413-50.287-108.791 0-65.891 37.155-100.744 80.176-141.1 41.35-38.788 87.577-82.158 97.767-158.843z"
}));

var SvgFlame = function SvgFlame(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Capa_1",
      enableBackground: "new 0 0 512.074 512.074",
      viewBox: "0 0 512.074 512.074",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFlame, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/flame.056d60f8.svg";
export { ForwardRef as ReactComponent };